const BRAND_KEY = 'b2b-brand';

export default {


  saveParams(brands) {
    window.localStorage.setItem(BRAND_KEY, JSON.stringify(brands));
  },

  loadBrands() {
    let code = window.localStorage.getItem(BRAND_KEY);
    if (code) {
      return JSON.parse(code);
    }
    return false;
  },

  clear() {
    window.localStorage.removeItem(BRAND_KEY);
  }
}



// WEBPACK FOOTER //
// ./src/components/brands/src/BrandStorage.js